import { render, staticRenderFns } from "./editarCursoModal.vue?vue&type=template&id=5a3e239e&"
import script from "./editarCursoModal.vue?vue&type=script&lang=js&"
export * from "./editarCursoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports